module.exports = __webpack_public_path__ + "img/zl4.bcd2433c.jpg";